import { Injectable } from "@angular/core";
import { NestApiProvider } from "../../nest-api";
import { RequestCreateReligionDto } from "../dto/religion.dto";
import { ResponseData } from "../../nest-responses";

@Injectable()
export class ReligionApi {
  private service: string = '';
  private model: string = 'religion';
  constructor(
    private nestApiProvider: NestApiProvider
  ) {

  }

  createReligion(payload: RequestCreateReligionDto) {
    const method: string = 'POST';
    const func: string = 'createReligion';
    const params = payload;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

  updateReligion(payload: RequestCreateReligionDto) {
    const method: string = 'POST';
    const func: string = 'updateReligion';
    const params = payload;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

  deleteReligion(payload: RequestCreateReligionDto) {
    const method: string = 'POST';
    const func: string = 'deleteReligion';
    const params = payload;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

  getAllReligion() {
    const method: string = 'GET';
    const func: string = 'getAllReligion';
    const params = {};
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

  getReligion(queryParams: { religionCode: string }) {
    const method: string = 'GET';
    const func: string = 'getReligion';
    const params = {};
    const urlParams: any = queryParams;
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/religion.api.ts